import { useMemo, type ReactElement } from 'react'
import ButtonBase from '@mui/material/ButtonBase'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import { useAppSelector } from '@/store'
import HashPackLogo from '@/public/images/logo-hashpack.svg'

import css from './styles.module.css'
import SvgIcon from '@mui/material/SvgIcon'
import { selectEnvironment } from '@/store/hederaSettingsSlice'

const WalletProviderSwitch = (): ReactElement => {
  const environment = useAppSelector(selectEnvironment)
  const isHedera = useMemo(() => environment === 'hedera', [environment])

  const tooltipText = useMemo(() => {
    return isHedera ? 'Switch to EVM wallet' : 'Switch to HashPack wallet'
  }, [isHedera])

  const handleClick = () => {
    const nextEnvironment = isHedera ? 'evm' : 'hedera'

    window.location.href = window.location.href.replace(`/${environment}/`, `/${nextEnvironment}/`)
  }

  return (
    <Tooltip title={tooltipText} arrow placement="bottom">
      <ButtonBase className={css.bell} onClick={handleClick}>
        <Badge
          variant="dot"
          color={isHedera ? 'success' : 'default'}
          sx={
            !isHedera
              ? {
                  '& .MuiBadge-badge': {
                    backgroundColor: 'grey.500',
                  },
                }
              : undefined
          }
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <SvgIcon component={HashPackLogo} inheritViewBox fontSize="medium" />
        </Badge>
      </ButtonBase>
    </Tooltip>
  )
}

export default WalletProviderSwitch
